import { DataExplorer, Property, Resource } from '../types/DataExplorer';

export const dataExplorer: DataExplorer = {
  fetching: true,
  failed: false,
  payload: {
    explorerTree: [],
    activeNode: null,
    activeNodeProperties: {
      fetching: true,
      failed: false,
      payload: []
    }
  }
};

export const emptyResource: Resource = {
  name: '',
  reference: '',
  source: '',
  vmid: ''
};

export const emptyProperty: Property = {
  inputBy: '',
  reference: '',
  secured: '',
  source: '',
  value: '',
  vmid: ''
};
